import { TableFieldModel } from '@/model/TableList'
import $currency from 'currency.js'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '采购编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'supplier',
    fieldName: '供应商',
    convert: ({ rowData }) => rowData.supplier?.name
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'accountAlias',
    fieldName: '供应商账户',
    convert: ({ rowData }) => rowData.accountInfo?.alias
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '总费用',
    isMoney: true,
    textAlign: 'right'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paid',
    fieldName: '已付款金额',
    textAlign: 'right',
    convert: ({ rowData }) => $currency(rowData.paid)
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoicedAmount',
    fieldName: '已开票金额',
    textAlign: 'right',
    convert: ({ rowData }) => $currency(rowData.invoicedAmount)
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税',
    formatType: 'boolean'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '税率',
    formatType: 'percent',
    textAlign: 'right'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'payCycle',
    fieldName: '付款周期'
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'delivery',
  //   fieldName: '发货方式'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'express',
  //   fieldName: '发货快递'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatusValue',
    fieldName: '开票状态'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'storageStatusValue',
    fieldName: '入库状态'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentStatusValue',
    fieldName: '付款状态'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUserName',
    fieldName: '创建人'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'requestUsers',
    fieldName: '采购申请人',
    convert: ({ rowData }) => rowData.requestUsers?.join(',') ?? '直接采购'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveUserName',
    fieldName: '审批人'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveTime',
    fieldName: '审批时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'statusValue',
    fieldName: '状态'
  }
]
